import { Flex } from "@chakra-ui/react";
import { Row, Col } from "antd";
import colors from "resources/theme/colors";

function TableHeaderRow() {
  return (
    <Flex as={Row} gutter={4} w="100%">
      <Flex as={Col} xs={2} bg={colors.black100}>
        <Flex ml={"46px"}>Composições</Flex>
      </Flex>
      <Flex as={Col} xs={3} bg={colors.black100}>
        <Flex ml={"46px"}>Descrição</Flex>
      </Flex>
      <Flex as={Col} xs={2} bg={colors.black100}>
        <Flex>Vencimento</Flex>
      </Flex>
      <Flex as={Col} xs={1} bg={colors.black100}>
        <Flex>Comp.</Flex>
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end" bg={colors.black100}>
        Nosso Número
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end" bg={colors.black100}>
        Principal
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end" bg={colors.black100}>
        Multa
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end" bg={colors.black100}>
        Juros
      </Flex>
      <Flex
        as={Col}
        xs={2}
        justifyContent="flex-end"
        bg={colors.black100}
        textAlign="end"
      >
        Tx. Cobrança
      </Flex>
      <Flex
        as={Col}
        xs={2}
        justifyContent="flex-end"
        bg={colors.black100}
        textAlign="end"
      >
        Correção Mon.
      </Flex>

      <Flex as={Col} xs={2} justifyContent="flex-end" textAlign="end">
        Dias atraso
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end" bg={colors.black100}>
        Total
      </Flex>
    </Flex>
  );
}

export default TableHeaderRow;
